import { render, staticRenderFns } from "./Removals.vue?vue&type=template&id=7f6d1672&scoped=true"
import script from "./Removals.vue?vue&type=script&lang=js"
export * from "./Removals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d1672",
  null
  
)

export default component.exports